import { render, staticRenderFns } from "./dispatch-info.vue?vue&type=template&id=7d1e62c9&scoped=true"
import script from "./dispatch-info.vue?vue&type=script&lang=js"
export * from "./dispatch-info.vue?vue&type=script&lang=js"
import style0 from "./dispatch-info.vue?vue&type=style&index=0&id=7d1e62c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1e62c9",
  null
  
)

export default component.exports